import { render, staticRenderFns } from "./remark-window.vue?vue&type=template&id=190d41ae&scoped=true&"
import script from "./remark-window.vue?vue&type=script&lang=js&"
export * from "./remark-window.vue?vue&type=script&lang=js&"
import style0 from "./remark-window.vue?vue&type=style&index=0&id=190d41ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d41ae",
  null
  
)

export default component.exports